module.exports = __webpack_public_path__ + "img/WW.eb40eec5.png";